<div class="sliderImgGallery flex-col" #imageThumbs>
    <div class="mainImg center-center flex-row flex-fill">
        @if (images.length > 1) {
            <div>
                <button mat-icon-button (click)="previousImage()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        }
        <div class="center-center flex">
            <cb-image-button [baseUrl]="selectedImage" [images]="images"> </cb-image-button>
        </div>
        @if (images.length > 1) {
            <div class="center-center">
                <button mat-icon-button (click)="nextImage()">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        }
    </div>
    @if (images.length > 1) {
        <div class="scroller" style="max-width: 450px; height: 125px">
            <ul>
                @for (image of images; track image; let i = $index) {
                    <li
                        class="image-thumb-{{ i }} flex"
                        [ngClass]="{ selectedImage: i === selectedIndex }"
                    >
                        <img class="flex" [src]="image" alt="img" (click)="selectImage(i)" />
                    </li>
                }
            </ul>
        </div>
    }
</div>
